// Copyright (c) 2016 Deere & Company

import app from './app';
import claims from './claims';
import home from './home';
import offlineReports from './offline-reports';
import oktaCallback from './okta-callback';
import partRequests from './part-requests';
import pips from './pips';
import products from './products';
import reimbursementSummary from './reimbursement-summary';
import rga from './rga';
import settings from './settings';
import tabm from './tabm';
import tcsm from './tcsm';

export const routes = state => ({
    childRoutes: [
        claims(state),
        offlineReports(state.user.security),
        oktaCallback,
        partRequests,
        pips,
        products(state),
        reimbursementSummary,
        rga,
        settings,
        tabm,
        tcsm
    ],
    indexRoute: home,
    ...app
});



// WEBPACK FOOTER //
// ./src/routes/index.js